import React, { useEffect } from "react";
import Header from "./header";
import Footer from "./footer";
import { Outlet } from "react-router-dom";
import { Navbar } from "./navbar";
import { SubElements } from "./subElements";
import RouteLoader from "../Loaders/RouteLoader";

export const MainLayout = () => {
  useEffect(() => {
    const html = document.documentElement;
    html.setAttribute("data-layout", "vertical");
    html.setAttribute("data-sidebar", "light");
    html.setAttribute("data-topbar", "light");
    html.setAttribute("data-layout-width", "fluid");
    html.setAttribute("data-layout-style", "default");
    if (!html.getAttribute("data-sidebar-size")) {
      html.setAttribute("data-sidebar-size", "lg");
    }
  }, []);

  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth >= 992) {
        document.body.classList.remove("vertical-sidebar-enable");
      }
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return (
    <div className="xcruit-app" id="layout-wrapper">
      <RouteLoader />
      <Header />
      <Navbar />
      <main>
        <Outlet />
      </main>
      <SubElements />
      <Footer />
    </div>
  );
};
